import { SharedPacksItemsController } from './shared-packs-items.controller'

function sharedPacksItems () {
  return {
    scope: {
      viewMode: '@', // "ACTIVE" | "EXPIRED" | "SEARCH"
      items: '<',
      sort: '<',
      order: '<',
      count: '<',
      loading: '<',
      loadingMore: '<',
      onLoadMore: '&',
      onChangeSort: '&',
      onItemUpdate: '&',
      selectedTab: '<?'
    },
    restrict: 'E',
    templateUrl: '/repository/directives/shared-packs-items/shared-packs-items.html?$$REVISION$$',
    controller: SharedPacksItemsController
  }
}

export { sharedPacksItems }
